import React from "react";
import { Card } from "../ui/card";
import { cn } from "../../lib/utils";

export function KpiCard({ title, value, icon: Icon, delta, kind = "info", suffix, testId }) {
  const kindClasses = {
    info: "bg-primary-subtle text-primary dark:bg-primary/15",
    success: "bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300",
    warning: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
    critical: "bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300",
    neutral: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  }[kind];

  return (
    <Card className="p-5" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <div className="label-eyebrow truncate">{title}</div>
          <div className="mt-2 flex items-baseline gap-1">
            <span className="text-2xl font-semibold text-foreground tabular-nums">
              {value}
            </span>
            {suffix && <span className="text-sm text-muted-foreground">{suffix}</span>}
          </div>
          {delta && (
            <div className="mt-1 text-xs text-muted-foreground">{delta}</div>
          )}
        </div>
        <div className={cn("w-10 h-10 rounded-md flex items-center justify-center shrink-0", kindClasses)}>
          <Icon className="w-5 h-5" />
        </div>
      </div>
    </Card>
  );
}
